//@ts-check
import { mustBeHtmlElement } from "common/dom-utils";

/**
 * The "Select Package(s) or Style(s)" section at the end of the font page
 * where users can add items to the cart.
 *
 * Parent:
 * - PurchasingSectionComponent
 *
 * Siblings:
 * - LicensingSelector
 */
export class FontsSelector {
  /** @type {FontsSelector | null} */
  static _instance = null;

  static getInstance() {
    if (!this._instance) {
      this._instance = new FontsSelector(
        mustBeHtmlElement(
          document.querySelector(".purchasable-items"),
          "fonts selector"
        )
      );
    }
    return this._instance;
  }

  /** @type {HTMLElement} */
  element;
  /** @type {HTMLElement | null} */
  _overlayElement = null;

  constructor(element) {
    this.element = element;
  }

  /**
   * Renders the blocking overlay with an error message box.
   * @param {string[]} errors
   */
  showDisabledMessage(errors) {
    if (!errors || errors.length === 0) {
      this.hideDisabledMessage();
      return;
    }

    // Build once and reuse so we can also update its contents on subsequent errors.
    if (!this._overlayElement) {
      this._overlayElement = document.createElement("div");
      this._overlayElement.className = "disabled-overlay";
      this._overlayElement.innerHTML =
        '<div class="disabled-message-container"><div class="error"></div></div>';
      this.element.appendChild(this._overlayElement);
    }

    const errorEl = mustBeHtmlElement(
      this._overlayElement.querySelector(".error"),
      "disabled overlay error"
    );
    errorEl.innerHTML = errors.join("<br>");
  }

  hideDisabledMessage() {
    if (this._overlayElement) {
      this._overlayElement.remove();
      this._overlayElement = null;
    }
  }
}
